import { AfterViewChecked, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { ChatMessage } from '../../interfaces/chat.interface';
import { CommonConstant } from 'src/shared/constants/common.constants';
import { ChatRoleEnum } from '../../enums/chat-role.enum';

@Component({
  selector: 'app-chat-box-messages',
  templateUrl: './chat-box-messages.component.html',
})
export class ChatBoxMessagesComponent implements AfterViewChecked {
  @ViewChildren('chatMessage') chatMessageElements: QueryList<ElementRef>;
  @Input() messages: ChatMessage[] = [];

  public dateFormat = CommonConstant.DATE_FORMAT_DISPLAY_2;
  public chatRoleEnum = ChatRoleEnum;

  public ngAfterViewChecked(): void {
    if (this.chatMessageElements) {
      const lastMessage = this.chatMessageElements?.last;
      if (lastMessage) {
        lastMessage.nativeElement.scrollIntoView({ behavior: 'smooth', block: "center" });
      }
    }
  }

  public messageIdTracker(index: number, item: ChatMessage) {
    return item.id;
  }
}
